import {Component} from '@angular/core';
import {ButtonComponent} from "../button.component";
import {IconTextModule} from "../../icon-text/icon-text.module";
import {SpinnerModule} from "../../spinner/spinner.module";

@Component({
    selector: 'app-secondary-button',
    standalone: true,
    imports: [
        IconTextModule,
        SpinnerModule
    ],
    templateUrl: './secondary.button.component.html',
    styleUrl: './secondary.button.component.css'
})
export class SecondaryButtonComponent extends ButtonComponent {


}
